import { h, Component } from 'preact';

import { copy } from 'utils/copy';

import PageLink from 'components/pageLink/pageLink';

import s from 'components/pages/error-404/error-404.sss';

export default class Error404 extends Component {

	componentDidMount() {
		const moviesSubpathMatch = location.pathname.match(/^\/movies\/([^/]+)\/.+/);
		if (moviesSubpathMatch) {
			location.href = `/movies/${moviesSubpathMatch[1]}/`;
		}
	}

	render() {
		return (
			<div class={s.wrapper}>
				<h2 class={s.title}>{copy('$404_TITLE')}</h2>
				<p class={s.content}>{copy('$404_CONTENT')}</p>
				<PageLink to="landing" class={s.link}>{copy('$404_LINK_HOME')}</PageLink>
			</div>
		);
	}

}